import { createApp } from '@app/adapters/create-app'

import AiOcrDocumentsUploader from '@app/application/ai_ocr_documents/components/ai-ocr-documents-uploader-per-section.vue'

export default (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    const element = doc.querySelector(
      "[data-behaviour='ai-ocr-documents-upload-per-section']"
    ) as HTMLElement

    if (element) {
      const { ledgerId, proposedDocuments, reconciliationTextId } =
        element.dataset ?? {}

      createApp(AiOcrDocumentsUploader, {
        ledgerId: ledgerId ? parseInt(ledgerId) : null,
        bannerIsExpanded: true,
        proposedDocuments: proposedDocuments
          ? JSON.parse(proposedDocuments)
          : [],
        reconciliationTextId: reconciliationTextId
          ? parseInt(reconciliationTextId)
          : null,
      }).mount(element)
    }
  })
}
